setUserUsernameAvailability